import { useState } from "react";

import { useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import { SearchResultLocations } from "components/NavBarSearchAppointments/components";
import { useSearchDropdown } from "components/NavBarSearchAppointments/components/SearchDropdown/hooks";
import "components/NavBarSearchAppointments/components/SearchDropdown/SearchDropdown.scss";
import { SEARCH_OPTION_TYPE } from "components/NavBarSearchAppointments/util";
import { DMS_CAPABILITIES } from "models";

import type { SearchResultsData } from "components/NavBarSearchAppointments/util";

type SearchDropdownProps = {
  data: SearchResultsData;
  isFetchingAppointments: boolean;
  onSelect: (id: string) => void;
  onClose: () => void;
  children?: React.ReactNode;
};

export const SearchDropdown = ({ data, isFetchingAppointments, onSelect, onClose }: SearchDropdownProps) => {
  const { dropdownRef, importAppointment, isImportAppointmentPending } = useSearchDropdown({ onClose, onSelect });
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const { selectedLocation } = useSelectedLocation();

  const handleOnClick = (id: string, type: SEARCH_OPTION_TYPE) => {
    if (type === SEARCH_OPTION_TYPE.Claire) onSelect(id);
    else {
      if (!selectedLocation?.dms_capability_ids?.includes(DMS_CAPABILITIES.Import)) return;

      setSelectedId(id);
      importAppointment(id);
    }
  };

  return (
    <div className="SearchDropdown-wrapper" ref={dropdownRef}>
      <SearchResultLocations
        data={data}
        isFetchingAppointments={isFetchingAppointments}
        handleOnClick={handleOnClick}
        isImportAppointmentPending={isImportAppointmentPending}
        selectedId={selectedId}
      />
    </div>
  );
};
